export const FLICK_TIME_MS = '500ms';
export const DEFAULT_TIMEOUT_MS = 1000;

export const MAX_VISIBLE_STEPS_COUNT = 35;
